import { Progress } from "@filadd/phi-plus-core";
import { css } from "@filadd/phi-plus-styled-system/css";

interface Props {
  percentage: number;
}

export const LinearProgressWithLabel = ({ percentage }: Props) => {
  return (
    <div className={css({ display: "flex", alignItems: "center" })}>
      <div
        className={css({
          width: {
            base: "150px",
            md: "200px",
          },
          mr: 4,
        })}
      >
        <Progress value={percentage} size="xs" />
      </div>

      {`${percentage}%`}
    </div>
  );
};
